<template>
  <div class="totals-box mb-2">
    <div class="totals-info-wrapper col">
      <router-link :to="{ path: '/jobs/edit/' + total.job_id }" target="_blank">
        <div class="total-ref-id pointer">{{ total.ref_id }}</div>
      </router-link>
      <div class="total-info">
        {{ total.move_date }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info">
        {{ total.customer }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info">
        {{ total.mover }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info">
        {{ total.total_time }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info-numbers">
        {{ total.hourly_price }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info-numbers col-width-40">
        {{ total.tips }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info-numbers col-width-40">
        {{ total.extras }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info-numbers col-width-50">
        {{ total.amount }}
      </div>
    </div>
    <div class="totals-info-wrapper d-flex flex-row position-relative col">
      <div class="total-info-numbers status pointer">
        <span v-if="isPaid" :class="'btn-status btn-active'" @click="markAsPaid(total)">
          <span>
            paid
          </span>
        </span>
        <span v-else :class="'btn-status btn-pending'" @click="markAsPaid(total)">
          <span>
            unpaid
          </span>
        </span>
      </div>
      <div v-if="!isPaid" class="total-info-numbers menu">
        <div id="dropdownMenuButtonEditExpenseDiscount"
             data-toggle="dropdown"
             aria-haspopup="true"
             aria-expanded="false"
        >
          <i class="fa fa-ellipsis-h text-secondary menu-icon"
             aria-hidden="true"
          />
        </div>
        <div class="dropdown-menu"
             aria-labelledby="dropdownMenuButtonEditExpenseDiscount"
        >
          <a class="dropdown-item p-1 small"
             href="#"
             @click="markAsPaid(total)"
          >
            Mark as paid</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  props: {
    total: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isPaid() {
      return this.total.is_paid === 1;
    },
  },
  methods: {
    markAsPaid(total) {
      axios
        .put(`/jobs/${total.job_id}/wages/${total.user_id}`, {
          amount: total.amount,
          is_paid: !total.is_paid,
        })
        .then(() => {
          this.$emit('update');
        });
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.totals-box {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0 2px 9px -4px rgba(15, 20, 54, 0.17), 0 7px 25px -3px rgba(50, 50, 93, 0.03);
  border-radius: 2px;
  height: 70px;
  padding: 8px 20px 8px 10px;
}
.totals-info-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.total-ref-id {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
}
.total-ref-id:hover {
  color: #2962ff;
}
.total-info {
  color: #4c5669;
}
.total-info-numbers {
  display: flex;
  align-items: center;
  color: #4c5669;
}
.totals-icon {
  color: #c0c6cc;
}
.col-width-40 {
  width: 40%;
  justify-content: center;
}
.col-width-50 {
  width: 50%;
  justify-content: center;
}
.menu {
  position: absolute;
  top: 30%;
  right: 10%;
}
.menu-icon {
  transform: rotate(90deg);
}
.status {
  position: absolute;
  top: 34%;
  left: 23%;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/MoverTotalsBlock.vue